import { Env } from '../../../env'

/**
 * Gets PayPal return and cancel URLs for order creation
 * These URLs are required by PayPal API but the actual flow is handled in the modal
 * The modal's onApprove/onCancel handlers manage the user experience
 *
 * @returns Object with returnUrl and cancelUrl pointing to the current page
 */
export function getPaypalReturnUrls(): {
  returnUrl: string
  cancelUrl: string
} {
  const baseUrl =
    Env.BASE_URL ||
    (typeof window !== 'undefined'
      ? window.location.origin
      : 'http://localhost:3000')
  // Use current page URL since the modal handles the flow
  const currentUrl =
    typeof window !== 'undefined' ? window.location.href : baseUrl
  return {
    returnUrl: currentUrl,
    cancelUrl: currentUrl,
  }
}
